import { useFrame } from "@react-three/fiber";

const SPEED_FACTOR = 0.01;

export const useAmbience = (callback: (rotationY: number) => void) => {
  useFrame(({ clock }) => {
    callback(clock.getElapsedTime() * SPEED_FACTOR);
  });
};
